//LIBRARIES
import React from 'react';
import Card from '@material-ui/core/Card';
import { CardText } from 'material-ui/Card';
import Dialog from 'material-ui/Dialog';
import SelectField from 'material-ui/SelectField';
import MenuItem from 'material-ui/MenuItem';
import { MdDelete as DeleteIcon } from 'react-icons/md';
import styled from 'styled-components';

//HELPERS
import { getTranslatedString } from 'helpers/i18n';
import { featureEnabled } from 'helpers/ToggleBot';

//COMPONENTS
import EditMaintenanceTicketForm from './EditMaintenanceTicketForm';

const StyledTransactionCard = styled(Card)`
  color: #424242 !important;
  font-family: 'Circular', sans-serif !important;
  height: 100%;
  overflow: hidden;
  border-radius: 8px;
`;

const TicketDetails = ({
  actions,
  confirmationDialogOpen,
  toggleDialog,
  hideDelete,
  hostIsBoardwalk,
  cancellationReason,
  cancellationOnChange,
  maintenanceTicket,
  showRecurrance,
  companyPreferences,
  updateTicket,
  readyOnly,
}) => {
  return (
    <div className="row">
      <h3 style={{ margin: '0 0 15px' }}>
        {getTranslatedString('landlordPortal.ticketDetailsOverview.overview')}
        <span style={{ float: 'right' }}>
          {!hideDelete && !hostIsBoardwalk && (
            <DeleteIcon onClick={toggleDialog} size={24} style={{ padding: 0 }} />
          )}
          <Dialog
            disableBackdropClick
            title={getTranslatedString('landlordPortal.ticketDetailsOverview.cancelTicketConfirm')}
            actions={actions}
            modal={false}
            open={confirmationDialogOpen}
            onRequestClose={toggleDialog}
            contentStyle={{ maxWidth: '500px' }}
          >
            <p>{getTranslatedString('landlordPortal.ticketDetailsOverview.pleaseSelect')}</p>
            <div className="row">
              <SelectField
                fullWidth
                value={cancellationReason}
                onChange={cancellationOnChange}
                errorText={!cancellationReason && getTranslatedString('required')}
              >
                <MenuItem
                  key="0"
                  primaryText={getTranslatedString(
                    'landlordPortal.ticketDetailsOverview.cancelNoIssue'
                  )}
                  value="cancelled"
                />
                <MenuItem
                  key="1"
                  primaryText={getTranslatedString(
                    'landlordPortal.ticketDetailsOverview.cancelDupIssue'
                  )}
                  value={'cancelled_dup'}
                />
                {featureEnabled('ui.maintenance.tickets.show_cancel_no_response') && (
                  <MenuItem
                    key="2"
                    primaryText={getTranslatedString(
                      'landlordPortal.ticketDetailsOverview.cancelNoResponse'
                    )}
                    value={'cancelled_no_res'}
                  />
                )}
              </SelectField>
            </div>
          </Dialog>
        </span>
      </h3>
      <MaintenanceTicketDetails
        maintenanceTicket={maintenanceTicket}
        showRecurrance={showRecurrance}
        companyPreferences={companyPreferences}
        onSubmit={(formData) => updateTicket(formData)}
      />
    </div>
  );
};

const MaintenanceTicketDetails = ({
  maintenanceTicket,
  showRecurrance,
  companyPreferences,
  onSubmit,
}) => {
  return (
    <StyledTransactionCard>
      <CardText expandable={true} style={{ padding: '0 0 10px' }}>
        <EditMaintenanceTicketForm
          ticketId={maintenanceTicket.id}
          onSubmit={onSubmit}
          formName={'edit_ticket_form'}
          initialValues={maintenanceTicket}
          showRecurrance={showRecurrance}
          companyPreferences={companyPreferences}
        />
      </CardText>
    </StyledTransactionCard>
  );
};

export default TicketDetails;
